var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAbout = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 35,
  x: 0.5,
  y: 0.5,
  fill: "#EAF0FD",
  fillOpacity: 0.75,
  rx: 3.931
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 35,
  x: 0.5,
  y: 0.5,
  stroke: "#2F64ED",
  rx: 3.931
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F64ED",
  d: "M25.44 22.106c0 1.68-1.392 3.06-3.128 3.06-1.735 0-3.126-1.38-3.126-3.06 0-1.681 1.39-3.06 3.126-3.06s3.127 1.379 3.127 3.06Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F64ED",
  d: "M10.932 22.144v-11.2h11.463c1.7.044 3.044 1.408 3.044 3.06 0 1.652-1.347 3.018-3.05 3.058l-.092.002h-5.112v5.124c-.045 1.646-1.422 2.977-3.127 2.977a3.105 3.105 0 0 1-3.126-3.021Z"
})));
export { SvgAbout as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIzNSIgaGVpZ2h0PSIzNSIgcng9IjMuOTMwNzciIGZpbGw9IiNFQUYwRkQiIGZpbGwtb3BhY2l0eT0iMC43NSIvPgo8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjM1IiBoZWlnaHQ9IjM1IiByeD0iMy45MzA3NyIgc3Ryb2tlPSIjMkY2NEVEIi8+CjxwYXRoIGQ9Ik0yNS40MzkyIDIyLjEwNTlDMjUuNDM5MiAyMy43ODY5IDI0LjA0ODEgMjUuMTY1NCAyMi4zMTIzIDI1LjE2NTRDMjAuNTc2NiAyNS4xNjU0IDE5LjE4NTUgMjMuNzg2OSAxOS4xODU1IDIyLjEwNTlDMTkuMTg1NSAyMC40MjUgMjAuNTc2NiAxOS4wNDY0IDIyLjMxMjMgMTkuMDQ2NEMyNC4wNDgxIDE5LjA0NjQgMjUuNDM5MiAyMC40MjUgMjUuNDM5MiAyMi4xMDU5WiIgc3Ryb2tlPSIjMkY2NEVEIi8+CjxwYXRoIGQ9Ik0xMC45MzE2IDIyLjE0MzZWMTAuOTQzNkwyMi4zOTU1IDEwLjk0NDdDMjQuMDk1MiAxMC45ODc4IDI1LjQzOTMgMTIuMzUxNyAyNS40MzkzIDE0LjAwMzFDMjUuNDM5MyAxNS42NTY0IDI0LjA5MjIgMTcuMDIxNSAyMi4zODk5IDE3LjA2MThMMjIuMzg4OSAxNy4wNjE4TDIyLjI5NyAxNy4wNjQxSDE3LjY4NTJIMTcuMTg1M0wxNy4xODUyIDE3LjU2NEwxNy4xODQxIDIyLjE4NzZDMTcuMTQwMiAyMy44MzM3IDE1Ljc2MzEgMjUuMTY1NCAxNC4wNTg0IDI1LjE2NTRDMTIuMzU3NyAyNS4xNjU0IDEwLjk3NjggMjMuODM3NiAxMC45MzE2IDIyLjE0MzZaIiBzdHJva2U9IiMyRjY0RUQiLz4KPC9zdmc+Cg==";